import { combineEpics } from "redux-observable";
import { epicQuickSellClose } from "./epics/epicQuickSellClose";
import { epicQuickSellResourceSell } from "./epics/epicQuickSellResourceSell";
export var epicQuickSell = combineEpics(epicQuickSellClose, epicQuickSellResourceSell);



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/epicQuickSell.ts
// module id = 2109
// module chunks = 3